(function (w, $) {
    'use strict';

    const assetId = '~/Parts/Views/User/UnsubscribeNewsletter.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    for (let ctx of w.umwAssets[assetId]) {

        const $mainPanel = $('#' + ctx.mainPanelID);
        const userToken = ctx.userToken;
        const labels = ctx.labels;

        $mainPanel.find('.js-resubscribe-lnk').click(function() {
            $.ajax({
                    url: w.R + 'handlers/public/userdata.ashx',
                    type: 'POST',
                    data: {
                        action: 'ResubscribeToNewsletter',
                        token: userToken
                    },
                    dataType: 'text'
                })
                .done(function() {
                    $mainPanel.find('.js-head-msg').text(labels.resubscribeSuccess);
                    $mainPanel.find('.js-result-msg').text(labels.resubscribeMsg);
                    $mainPanel.find('.js-resubscribe-msg').hide();
                })
                .fail(function(ex) {
                    let msg = ex.statusText ? ex.statusText : 'Resubscription failed due to unknown error';
                    try {
                        msg = JSON.parse(ex.responseText).Message;
                    } catch (e) {
                    }
                    const notyOptions = {
                        layout: 'topCenter',
                        type: 'error',
                        maxVisible: 15,
                        force: true,
                        timeout: 5000,
                        text: msg
                    };
                    w.noty(notyOptions);
                });
        });
    }
})(window, jQuery);